import React, { useEffect, useRef, useState } from 'react';
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

const formatDuration = hours => {
  if (hours == null) return '';
  const totalMinutes = Math.round(parseFloat(hours) * 60);
  const h = Math.floor(totalMinutes / 60);
  const m = totalMinutes % 60;
  const hPart = h > 0 ? `${h}h` : '';
  const mPart = m > 0 ? `${m}m` : '';
  return `${hPart}${hPart && mPart ? ' ' : ''}${mPart || (hPart ? '' : '0m')}`;
};

function DowntimeDonutChart({ totals, total }) {
  const chartRef = useRef(null);
  const [legendHeight, setLegendHeight] = useState(0);

  useEffect(() => {
    if (chartRef.current) {
      setLegendHeight(chartRef.current.legend?.height || 0);
    }
  }, []);

  const data = {
    labels: totals.map(t => t.label),
    datasets: [
      {
        data: totals.map(t => t.value),
        backgroundColor: ['#22c55e', '#3b82f6', '#f59e0b', '#ef4444'],
        borderColor: ['#22c55e', '#3b82f6', '#f59e0b', '#ef4444'],
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    animation: { animateRotate: true, duration: 800 },
    plugins: {
      legend: {
        position: 'top',
        labels: {
          color: '#ffffff',
          boxWidth: 12,
          usePointStyle: true,
          pointStyle: 'circle',
          font: { size: 12 },
        },
      },
      tooltip: {
        callbacks: {
          label: ctx => `${ctx.label}: ${formatDuration(ctx.parsed)}`,
        },
      },
    },
  };

  const labelPlugin = {
    id: 'doughnutLabel',
    afterDatasetsDraw: chart => {
      const { ctx } = chart;
      const meta = chart.getDatasetMeta(0);
      const ds = chart.data.datasets[0];
      meta.data.forEach((arc, i) => {
        const value = ds.data[i];
        if (value === 0) return;
        const angle = (arc.startAngle + arc.endAngle) / 2;
        const radius = (arc.outerRadius + arc.innerRadius) / 2;
        const x = arc.x + radius * Math.cos(angle);
        const y = arc.y + radius * Math.sin(angle);
        ctx.save();
        ctx.fillStyle = '#000';
        ctx.font = 'bold 12px sans-serif';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText(formatDuration(value), x, y);
        ctx.restore();
      });
    },
  };

  return (
    <div className="relative flex-1 mt-2">
      <Doughnut ref={chartRef} data={data} options={options} plugins={[labelPlugin]} />
      <div
        className="absolute left-0 right-0 flex flex-col items-center justify-center pointer-events-none text-white"
        style={{ top: legendHeight, bottom: 0 }}
      >
        <span className="font-semibold text-sm">Total</span>
        <span className="text-xs">{formatDuration(total)}</span>
      </div>
    </div>
  );
}

export default DowntimeDonutChart;

